const stylesId = 'nuxt-progress-styles';

/**
 * Hide nuxt progress bar by injecting styles.
 * There is no way to hide it dynamically eg by $nuxt.$loading.hide(), but you could use:
 * - this.$axios.$get('URL', { progress: false })
 *
 *
 * https://nuxtjs.org/docs/configuration-glossary/configuration-loading/
 */
export default {
  hide: () => {
    if (!process.client || document.getElementById(stylesId)) return;
    const styles = document.createElement('style');
    styles.id = stylesId;
    styles.innerText = `
      #__nuxt .nuxt-progress { display: none !important; }
    `;
    document.head.appendChild(styles);
  },

  show: () => {
    if (!process.client) return;
    (document.getElementById(stylesId) as HTMLStyleElement)?.remove();
  },
};
